import React from 'react';
import PropTypes from 'prop-types';

const backgroundStyle = {
    backgroundColor: '#651E1E',
    color: '#d3d4c2',
    display: 'flex',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    flexDirection: 'column',
    alignItems: 'left',
    padding: '10px'
};
const DeveloperError = ( { errorStack } ) => (
    <div style={backgroundStyle}>
        <span style={{ whiteSpace: 'pre' }}>{errorStack}</span>
    </div>
);

DeveloperError.propTypes = {
    errorStack: PropTypes.string.isRequired
};

export default DeveloperError;
